import Vue from "vue";
import { i18n } from "@/services/i18n/i18n";

Vue.filter("accountType", (value: string) => {
  return i18n.t(`common.userTypes[${value}]`);
});
